var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tabs"},_vm._l((_vm.itemList),function(item){return _c('button',{key:item.value,staticClass:"item",class:[
        { on: _vm.on === item.value },
        { hasIcon: item.icon },
        { onlyIcon: _vm.hideLabel },
        {disabled: item.disabled}
    ],on:{"click":function($event){return _vm.$emit('select', item.value)}}},[(item.icon)?_c('i',{staticClass:"icon default",class:item.icon}):_vm._e(),(item.iconHover)?_c('i',{staticClass:"icon hover",class:item.iconHover}):_vm._e(),(item.iconActive)?_c('i',{staticClass:"icon active",class:item.iconActive}):_vm._e(),(!_vm.hideLabel)?_c('p',{staticClass:"text"},[_vm._v(_vm._s(item.label || item.value))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }